import type { GameController } from "../../app/controller";
import { PieceIcon } from "../components/PieceIcon";

export function HandoffScreen(props: { controller: GameController }) {
  const c = props.controller;
  const name = () => c.store.state.players[c.viewer()].name;

  return (
    <div class="overlay">
      <div class="overlay-card">
        <div class="big-glyph">
          <PieceIcon type="pawn" owner={c.viewer()} />
        </div>
        <h2>{name()}'s turn</h2>
        <p>Pass the device over. Tap below when you're ready — your hand stays hidden until then.</p>
        <button class="btn btn-primary" onClick={() => c.reveal()}>
          I'm {name()} — show my turn
        </button>
      </div>
    </div>
  );
}
